module.exports = __webpack_public_path__ + "img/logo-white.6b0d2433.svg";